import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 18 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#171717",
      "fill-rule": "evenodd",
      d: "M9.588 1.5c.487 0 .907.315 1.057.75.045.12.068.24.068.375s-.023.255-.068.375A1.122 1.122 0 0 1 8.53 3a1 1 0 0 1-.067-.375c0-.135.022-.255.067-.375.15-.435.57-.75 1.058-.75M.648 3H7.75a1.875 1.875 0 0 0 3.675 0h1.927c.218 0 .398-.165.398-.375s-.18-.375-.398-.375h-1.927a1.875 1.875 0 0 0-3.675 0H.648c-.218 0-.398.165-.398.375S.43 3 .647 3M3.355 9.75a1 1 0 0 1-.067-.375c0-.135.022-.255.067-.375A1.122 1.122 0 0 1 5.47 9c.045.12.067.24.067.375s-.022.255-.067.375a1.122 1.122 0 0 1-2.115 0M.25 9.375c0 .21.18.375.397.375h1.928a1.875 1.875 0 0 0 3.675 0h7.102c.218 0 .398-.165.398-.375S13.57 9 13.352 9H6.25a1.875 1.875 0 0 0-3.675 0H.647c-.216 0-.397.165-.397.375",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }